export const BOOKING_OVERRIDES = {} as any;
